<script setup lang="ts">

type SpinnerType = 'light' | 'dark' | 'purpleCustom'

interface Props {
  type?: SpinnerType
  size?: number
}

withDefaults(defineProps<Props>(), {
  type: 'light',
  size: 20
})
</script>

<template>
  <svg
    class="spinner-loader"
    :class="`spinner-loader--${type}`"
    viewBox="0 0 50 50"
    :style="{ width: `${size}px`, height: `${size}px` }"
  >
    <circle class="background" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
  </svg>
</template>

<style scoped>
.spinner-loader {
  animation: spin 1s linear infinite;
}

.spinner-loader--light .background {
  stroke: rgba(255, 255, 255, 0.3);
}

.spinner-loader--light .path {
  stroke: #fff;
}

.spinner-loader--dark .background {
  stroke: rgba(0, 0, 0, 0.1);
}

.spinner-loader--dark .path {
  stroke: #333;
}

.spinner-loader--purpleCustom .background {
  stroke: rgba(0, 0, 0, 0.1);
}

.spinner-loader--purpleCustom .path {
  @apply stroke-purpleCustom;
}

.path {
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -125;
  }
}
</style>
